const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSustainableGreenSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#489B6D"
    },
    d: "M440.425,68.993l-4.521,4.884C387.68,26.236,323.802,0,256,0C193.842,0,133.905,22.553,87.231,63.503 C31.795,112.145,0,182.307,0,256c0,9.864,7.997,17.86,17.86,17.86s17.86-7.997,17.86-17.86c0-63.411,27.361-123.786,75.069-165.645 C150.945,55.123,202.515,35.721,256,35.721c58.419,0,113.453,22.633,154.967,63.727c0.223,0.22,0.461,0.413,0.692,0.619 l-5.301,5.727c-6.694,7.232-1.116,18.93,8.717,18.278l32.894-2.177c5.586-0.369,9.984-4.912,10.173-10.506l1.173-34.627 C459.658,66.675,447.283,61.584,440.425,68.993z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2CE86"
    },
    d: "M17.86,273.86C7.997,273.86,0,265.864,0,256c0-73.693,31.795-143.855,87.231-192.497 C133.905,22.553,193.842,0,256,0v35.721c-53.485,0-105.055,19.402-145.21,54.634C63.082,132.214,35.721,192.589,35.721,256 C35.721,265.864,27.724,273.86,17.86,273.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#489B6D"
    },
    d: "M256,512c-62.153,0-122.087-22.549-168.759-63.495c-7.416-6.505-8.153-17.789-1.648-25.205 c6.506-7.416,17.789-8.153,25.205-1.648c40.154,35.227,91.721,54.627,145.202,54.627c62.833,0,122.841-26.945,164.638-73.929 c35.88-40.333,55.641-92.306,55.641-146.35c0-9.864,7.997-17.86,17.86-17.86S512,246.136,512,256 c0,62.807-22.969,123.212-64.674,170.094C398.758,480.688,329.022,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2CE86"
    },
    d: "M110.798,421.652c-0.652-0.572-1.343-1.068-2.049-1.529l4.52-4.883 c6.694-7.232,1.116-18.93-8.718-18.278l-32.894,2.177c-5.586,0.369-9.984,4.912-10.173,10.506l-1.173,34.627 c-0.342,10.09,12.033,15.181,18.89,7.773l5.646-6.1c0.701,0.912,1.497,1.773,2.394,2.56C133.913,489.451,193.847,512,256,512 v-35.721C202.519,476.279,150.952,456.879,110.798,421.652z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#91C0F1"
    },
    cx: 256,
    cy: 256,
    r: 161.351
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7EDF3"
    },
    d: "M256,417.349c-89.111,0-161.349-72.238-161.349-161.349S166.889,94.651,256,94.651V417.349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2CE86"
    },
    d: "M184.672,312.127l2.372-2.624c8.094-8.958,7.938-22.633-0.357-31.405l-1.267-1.341 c-5.434-5.746-7.556-13.87-5.626-21.541c2.531-10.058-1.942-20.572-10.944-25.724l-61.404-36.559 C99.21,212.307,94.651,233.621,94.651,256c0,63.517,36.708,118.452,90.061,144.775l-5.677-69.236 C177.838,324.546,179.916,317.391,184.672,312.127z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007AB7"
    },
    d: "M369.959,141.781l-10.661,11.651c-4.64,5.071-11.118,8.075-17.987,8.342l-48.217,1.872 c-8.547,0.332-16.37,4.888-20.875,12.158l-12.359,19.944c-5.588,9.018-5.07,20.541,1.306,29.02l7.676,10.208 c5.826,7.749,8.954,17.192,8.904,26.887l-0.163,31.643c-0.086,16.666,14.905,29.364,31.33,26.537l35.149-6.049 c9.66-1.662,18.497-6.477,25.132-13.693l0,0c11.802-12.838,29.386-17.106,45.029-12.571c2.047-10.26,3.127-20.868,3.127-31.731 C417.349,211.379,399.234,170.989,369.959,141.781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007AB7"
    },
    d: "M265.099,378.549L265.099,378.549c-10.741,4.762-16.91,16.177-15.011,27.772l1.799,10.977 c1.367,0.035,2.737,0.052,4.113,0.052c26.081,0,50.712-6.196,72.513-17.184l-2.748-4.095 C312.478,376.276,286.894,368.886,265.099,378.549z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2CE86"
    },
    d: "M186.349,158.508l32.729-18.42c5.147-2.897,8.878-7.781,10.32-13.508l7.757-30.827 c-36.776,4.279-69.778,20.918-94.739,45.662l20.342,15.468C169.593,162.081,178.864,162.72,186.349,158.508z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSustainableGreenSvgrepoCom);
export default __webpack_public_path__ + "static/media/sustainable-green-svgrepo-com.3d8fc2f7560ddfd24c2a0f0ae7dc2791.svg";
export { ForwardRef as ReactComponent };